import { render } from "./CourseOption.vue?vue&type=template&id=b2a948b4&scoped=true"
import script from "./CourseOption.vue?vue&type=script&lang=js"
export * from "./CourseOption.vue?vue&type=script&lang=js"

import "./CourseOption.vue?vue&type=style&index=0&id=b2a948b4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2a948b4"]])

export default __exports__